import { Button, Paper, Box, Typography } from '@mui/material';
import { ColorPicker, useColor, Hue } from "react-color-palette";
import "react-color-palette/css";

function ColorPickerPopup({ initialColor, handleCancel, handleSave, title }) {
  const [color, setColor] = useColor(initialColor);

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'absolute', top:0, left:0, width:'100%', height:'100%' }} onClick={handleCancel}></div>
        <Paper style={{ zIndex: 1000 }}>
            <div style={{ padding: '20px', minWidth: '250px' }}>
            <Box sx={{ display: 'flex', flexDirection: "row", alignItems: 'center', width: '100%' }}>
                <Typography variant='h6' sx={{ flexGrow: 1 }}>{title}</Typography>
                {/* Color preview box */}
                <Box sx={{width: '40px', height: '40px', borderRadius: '5px', backgroundColor: color.hex}}></Box>
            </Box>
            <Box sx={{marginTop: '25px'}}>
                <Hue color={color} onChange={setColor}/>
            </Box>
            {/* <ColorPicker color={color} onChange={setColor} hideHSV dark /> */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '35px' }}>
                <Button onClick={handleCancel} variant='outlined' sx={{ marginRight: '10px' }}>Cancel</Button>
                <Button variant="contained" onClick={() => handleSave(color.hex, color.rgb)}>Save</Button>
            </Box>
            </div>
        </Paper>
    </div>
  );
}

export default ColorPickerPopup;